export default ({ vnode }) => {
  return vnode?.context
}
